import { Outlet } from "react-router-dom";
import Navbar from "../components/Layout/Navbar";
import Footer from "../components/Layout/Footer";
import Chatbot from "../components/Layout/Chatbot";

export default function Layout() {
    return (
        <>
            <Navbar />
            <Outlet />
            <Footer />
            <Chatbot />
        </>
    );
}